<!--
 * @Author: DYM
 * @Date: 2020-03-16 14:36:50
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-21 18:02:44
 * @Description: 用户管理
 -->
<template>
  <el-row
    v-loading="loading"
    type="flex"
    class="l-page l-page--nav page-user"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :md="8"
      :span="10"
    >
      <!-- 左侧头部 Start -->
      <div
        class="l-page--inner l-page--aside"
      >
        <div
          class="l-page__header"
        >
          <!-- 左侧标题 -->
          <h2
            class="c-page__header-title"
          >
            组织树
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  ref="deptTree"
                  class="o-tree-overflow--unset"
                  highlight-current
                  lazy
                  :load="loadDeptTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
          </hm-page-card>
        </div>
        <!-- 左侧导航主内容 End -->
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <!-- 右侧用户信息 -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :md="16"
      :span="14"
    >
      <!-- 右侧内容：查询类布局 Start -->
      <div
        class="l-page--inner l-page--search"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 右侧标题 -->
          <h2
            class="c-page__header-title"
          >
            用户信息
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            >
              查询
            </el-button>
            <el-button
              icon="kestrel-icon ki-repeat"
              @click="resetForm()"
            >
              重置
            </el-button>
            <el-button
              type="success"
              icon="kestrel-icon ki-plus"
              @click="handleAddUser()"
            >
              新增
            </el-button>
            <el-button
              type="success"
              icon="kestrel-icon ki-edit"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleEdit(selectedRow)"
            >
              修改
            </el-button>
            <el-button
              type="warning"
              icon="kestrel-icon ki-undo"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleResetPwd(selectedRow)"
            >
              重置密码
            </el-button>
            <el-button
              type="primary"
              icon="kestrel-icon ki-unlock"
              plain
              :disabled="!selectedRow.userCode || selectedRow.locked!=='Y'"
              @click="handleUnlock(selectedRow)"
            >
              用户解锁
            </el-button>
          </div>
          <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 查询条件 Start -->
        <div
          class="l-page__item l-page--search__item"
        >
          <hm-page-card
            title="查询条件"
            class="c-card--condition"
          >
            <!-- 查询条件表单 Start -->
            <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
            <el-form
              ref="filterParams"
              class="c-form c-condition__form"
              :model="filterParams"
              :inline="true"
              label-position="right"
              label-width="90px"
              label-suffix="："
            >
              <el-row
                class="c-form__row"
              >
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="用户编码"
                    prop="userCode"
                  >
                    <el-input
                      v-model.trim="filterParams.userCode"
                      class="c-form__input"
                      placeholder="用户编码"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="用户名称"
                    prop="userName"
                  >
                    <el-input
                      v-model.trim="filterParams.userName"
                      class="c-form__input"
                      placeholder="用户名称"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
                <!-- <el-col
                  class="c-form__col"
                  :span="10"
                >
                  <el-form-item
                    class="c-form__item"
                    label="搜索范围"
                    prop="searchType"
                  >
                    <el-radio-group
                      v-model="filterParams.searchType"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="(value,key) in searchType"
                        :key="key"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-form>
            <!-- 查询条件表单 End -->
          </hm-page-card>
        </div>
        <!-- 查询条件 End -->

        <!-- 页面主内容：查询列表 Start -->
        <div
          class="l-page__body l-page--search__body"
        >
          <div
            class="l-flex--column l-flex--full l-flex--equally dev-l-userInfo"
          >
            <!-- 用户信息 -->
            <div
              class="l-flex--column__item"
            >
              <hm-page-card
                title="用户列表"
                class="c-card--table"
              >
                <div
                  class="c-page__pTable"
                >
                  <!-- table的ref的命名根据业务名称修改 -->
                  <el-table
                    ref="attrUserTable"
                    class="c-page__table o-header-text-center"
                    height="100%"
                    stripe
                    border
                    highlight-current-row
                    tooltip-effect="dark"
                    :data="page.rows"
                    :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
                    :row-class-name="tableRowClassName"
                    @row-click="handleRowClick"
                  >
                    <el-table-column
                      class-name="c-table-column--selection"
                      width="30"
                    >
                      <template
                        slot-scope="scope"
                      >
                        <el-radio
                          v-model="selectedRow.userCode"
                          :label="scope.row.userCode"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="userCode"
                      label="用户编码"
                      width="120"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="userName"
                      label="用户名称"
                      min-width="120"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="tel"
                      label="联系电话"
                      width="120"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="email"
                      label="邮箱"
                      width="140"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="lockedName"
                      label="锁定状态"
                      width="80"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span :class="{'u-text-success': scope.row.locked ==='N', 'u-text-danger': scope.row.locked ==='Y'}">
                          {{ scope.row.lockedName }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="validName"
                      label="有效标志"
                      width="80"
                      align="center"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="sourceTypeName"
                      label="数据来源"
                      width="80"
                      align="center"
                      show-overflow-tooltip
                    />
                    <template v-for="(attrUserItem, index) in attrUserList">
                      <template v-if="attrUserItem.attrType==='Date'">
                        <el-table-column
                          :key="'attrUser'+ index"
                          :prop="attrUserItem.attrKey"
                          :label="attrUserItem.attrName"
                          width="120"
                          align="center"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            {{ scope.row[attrUserItem.attrKey] | date('yyyy-MM-dd') }}
                          </template>
                        </el-table-column>
                      </template>
                      <template v-else-if="attrUserItem.enums">
                        <el-table-column
                          :key="'attrUser'+ index"
                          :prop="attrUserItem.attrKey"
                          :label="attrUserItem.attrName"
                          :min-width="attrUserItem.attrName.length > 3 ? attrUserItem.attrName.length * 24 : 90"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            {{ scope.row[attrUserItem.attrKey+'_name'] }}
                          </template>
                        </el-table-column>
                      </template>
                      <template v-else>
                        <el-table-column
                          :key="'attrUser'+ index"
                          :prop="attrUserItem.attrKey"
                          :label="attrUserItem.attrName"
                          :min-width="attrUserItem.attrName.length > 3 ? attrUserItem.attrName.length * 24 : 90"
                          show-overflow-tooltip
                        />
                      </template>
                    </template>
                  </el-table>
                  <el-pagination
                    class="c-page__pagination"
                    :disabled="page.total<=0 || loading"
                    :page-size="page.pageSize"
                    :total="page.total"
                    :current-page="page.pageNo"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10,15,20]"
                    @current-change="search"
                    @size-change="handleSizeChange"
                  />
                </div>
              </hm-page-card>
            </div>

            <!-- 身份信息 -->
            <div
              class="l-flex--column__item"
            >
              <!-- 用户身份信息列表组件 -->
              <capacity-list
                :is-loading.sync="loading"
                :user-code="selectedRow.userCode"
                :user-source-type="selectedRow.sourceType"
                :is-search.sync="isSearchCapacity"
                :attr-capacity.sync="attrCapacityList"
                @handleAddCapacity="handleAddCapacity"
                @dialogControl="handleDialogControl"
              />
            </div>
          </div>
        </div>
        <!-- 页面主内容：查询列表 End -->
      </div>
      <!-- 右侧内容：查询类布局 End -->
    </el-col>
    <!-- 右侧主面板模块 End -->

    <!-- 用户新增弹窗组件 -->
    <add-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
      @addCapacityToDept="addToDept"
    />

    <!-- 用户修改弹窗组件 -->
    <edit-dialog
      v-if="showDialogName==='edit'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />

    <!-- 由新增用户跳转的在本机构下新增身份组件 -->
    <add-capacity-dialog
      v-if="showDialogName==='addCapacityToDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch"
    />

    <!-- 用户身份新增、修改组件 -->
    <update-capacity-dialog
      v-if="showDialogName==='addCapacity' || showDialogName==='editCapacity'"
      :dl-params="dialogParams"
      :attr-capacity-list="attrCapacityList"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 身份岗位关联组件 -->
    <relate-role-dialog
      v-if="showDialogName==='relateRole'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 身份权限部门关联组件 -->
    <relate-permission-dept-dialog
      v-if="showDialogName==='relatePermissionDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />
  </el-row>
</template>

<script>
import { deptTree, userService, attrUser } from './user.service.js';
import capacityList from './capacity/capacity.vue';
import addDialog from './addDialog.vue';
import editDialog from './editDialog.vue';
import updateCapacityDialog from './capacity/updateDialog';
import relatePermissionDeptDialog from './capacity/relatePermissionDeptDialog';
import relateRoleDialog from './capacity/relateRoleDialog';
import addCapacityDialog from './capacity/addCapacityDialog';

export default {
  name: 'User',
  components: {
    capacityList,
    addDialog,
    editDialog,
    updateCapacityDialog,
    relateRoleDialog,
    addCapacityDialog,
    relatePermissionDeptDialog
  },
  data () {
    return {
      loading: false, // 页面loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        userCode: null,
        userName: null,
        searchType: 'TARGET'
      },
      /* 查询条件 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},

      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNo: 0
      },
      /* 查询结果 End */

      selectedRow: {}, // 用户列表选中行
      currentDeptCode: null, // 当前选择部门的代码
      currentDeptName: null, // 当前选择部门的名称

      isSearchCapacity: false, // 为true时重新查询身份列表

      /* 扩展字段 Start */
      attrUserList: [], // 用户
      attrCapacityList: [], // 身份
      /* 扩展字段 End */

      /* 树组件配置 Start */
      defaultProps: {
        label: 'deptName',
        children: 'children',
        isLeaf: (data, node) => {
          return !data.xjbz;
        }
      },
      /* 树组件配置 End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  computed: {
    // 部门类型
    searchType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.USER_SEARCH_TYPE) {
        return enums.USER_SEARCH_TYPE;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 机构部门树加载
     * @param {Object} node
     * @param {any} resolve
     * @return {*}
     */
    loadDeptTree (node, resolve) {
      this.loading = true;
      this.getDeptTree(node.data, resolve);
    },
    /**
     * @description: 获取机构部门树数据
     * @param {Object} _data
     * @param {any} _resolve
     * @return {*}
     */
    getDeptTree (_data, _resolve) {
      const params = {};
      if (_data) {
        params.deptCode = _data.deptCode;
      }
      deptTree(params)
        .then(rsp => {
          _resolve(rsp.data);
        }).catch(err => {
          console.error('查询机构树出错', err);
        }).finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 树节点点击事件
     * @param {Object} data
     * @param {Object} node
     * @return {*}
     */
    handleNodeClick (data, node) {
      this.currentDeptCode = data.deptCode;
      this.currentDeptName = data.deptName;
      this.selectedRow = {};
    },
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      // 获取用户扩展字段
      attrUser()
        .then(rsp => {
          this.attrUserList = rsp.data;
          this.$nextTick(() => {
            this.$refs.attrUserTable.doLayout();
          });
        })
        .catch(err => {
          console.error('获取用户扩展字段错误！', err);
        });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @param {*}
     * @return {*}
     */
    refreshSearch () {
      if (!this.currentDeptCode) {
        this.$alert('请选择机构部门！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.trueFilterParams.deptCode = this.currentDeptCode;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 start */

      this.loading = true;
      userService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 移除单选按钮选中行
          this.selectedRow = {};

          this.$nextTick(() => {
            this.$refs.attrUserTable.doLayout();
          });
        })
        .catch(err => {
          console.error('查询用户出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置表单
     * @param {*}
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 表格选中行事件
     * @param {Object} row
     * @param {Object} column
     * @param {any} event
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.selectedRow = row;
    },
    /**
     * @description: 表格行背景颜色渲染处理
     * 背景色提供：is-warning(黄色)，is-danger(红色)，is-success(绿色)
     * （右键操作搭配is-warning）
     * @param {Object}
     * @return {*}
     */
    tableRowClassName ({ row, rowIndex }) {
      if (this.$HMUtil.Objdiff(row, this.contextMenuRow)) {
        return 'is-warning';
      }
      return '';
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    handleAddUser () {
      if (!this.currentDeptCode) {
        this.$alert('请选择机构部门！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      this.handleDialog('add', { deptCode: this.currentDeptCode, deptName: this.currentDeptName });
    },
    /**
     * @description: 用户解锁
     * @param {Object} _rowData, 用户信息
     * @return {*}
     */
    handleUnlock (_rowData) {
      const _this = this;
      _this.$confirm(`是否确认解锁用户【${_rowData.userName}】？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        userService.unlock(_rowData.userCode)
          .then(rsp => {
            _this.$alert('解锁成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search(_this.trueFilterParams.pageNo);
          })
          .catch(err => {
            console.error('用户解锁出错', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {

      });
    },
    /**
     * @description: 用户密码重置
     * @param {String} userCode
     * @param {String} userName
     * @return {*}
     */
    handleResetPwd (_rowData) {
      const _this = this;
      if (_rowData.sourceType === '1') {
        _this.$alert('当前用户信息数据来源为“同步”，不能重置密码', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      _this.$confirm(`是否把用户【${_rowData.userName}】的登录密码重置为初始密码 ？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        userService.resetPwd(_rowData.userCode)
          .then(rsp => {
            _this.$alert('密码重置成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search(_this.trueFilterParams.pageNo);
          })
          .catch(err => {
            console.error('密码重置出错！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 用户删除
     * @param {String} userCode
     * @param {String} userName
     * @return {*}
     */
    handleDelUser (userCode, userName) {
      const _this = this;
      _this.$confirm(`是否确认删除用户【${userName}】？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        userService.delUser(userCode)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search(_this.trueFilterParams.pageNo);
          })
          .catch(err => {
            console.error('删除出错！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 用户修改
     * @param {Object} 当前选中行的用户数据
     */
    handleEdit (_rowData) {
      if (_rowData.sourceType === '1') {
        this.$alert('当前用户信息数据来源为“同步”，不能修改用户信息', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      this.handleDialog('edit', { userCode: _rowData.userCode });
    },
    /**
     * @description: 在当前部门新增身份
     * @param {Object} _data
     * @return {*}
     */
    addToDept (_data) {
      const params = {
        deptCode: this.currentDeptCode,
        deptName: this.currentDeptName,
        userCode: _data.userCode
      };
      // 在当前部分添加用户身份（由新增用户跳转）
      this.handleDialog('addCapacityToDept', params);
    },
    /**
     * @description: 新增用户身份
     * @param {*}
     * @return {*}
     */
    handleAddCapacity () {
      this.addCapacity(this.selectedRow);
    },
    /**
     * @description: 用户身份新增参数组装
     * @param {*}
     * @return {*}
     */
    addCapacity (_row) {
      const params = {
        deptCode: this.currentDeptCode,
        deptName: this.currentDeptName,
        userName: _row.userName,
        userCode: _row.userCode,
        joinTime: _row.joinTime
      };
      this.handleDialog('addCapacity', params);
    },
    /**
     * @description: 操作刷新身份列表
     * @param {*}
     * @return {*}
     */
    handleSearchCapacity () {
      this.isSearchCapacity = true;
    },
    /**
     * @description: 用户身份列表功能操作控制
     * @param {String} _type，操作类型
     * @param {Object} _data，列表传参
     */
    handleDialogControl (_type, _data) {
      switch (_type) {
        case 'edit':
          this.handleDialog('editCapacity', _data);
          break;
        case 'relateRole':
          this.handleDialog('relateRole', _data);
          break;
        case 'relatePermissionDept':
          this.handleDialog('relatePermissionDept', _data);
          break;
        default:
          break;
      }
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    }
  },
  watch: {
    currentDeptCode: function (newVal) {
      if (newVal) {
        this.refreshSearch();
        this.selectedRow.userCode = null;
      }
    }
  },
  created () {
    this.getAttr();
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.attrUserTable.doLayout();
    });
  }
};
</script>

<style lang="scss">
.theme-default .page-user{
  .dev-l-userInfo {
    .c-card__header {
      padding: 4px 4px 4px 10px;
      border: 1px solid #dfe7fd;
      border-bottom: 0;
      border-left: 4px solid #0755c2;
      line-height: 24px;
      background: #f2f6fc;
    }

    .l-card__body {
      padding: 0;
    }
  }
}
</style>
